import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mt-4" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body py-4" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = { class: "text-start w-70px" }
const _hoisted_9 = { class: "w-70px text-end" }
const _hoisted_10 = { class: "min-w-60px text-end" }
const _hoisted_11 = { class: "min-w-40px text-end" }
const _hoisted_12 = { class: "min-w-60px text-end" }
const _hoisted_13 = { class: "min-w-60px text-end" }
const _hoisted_14 = { class: "min-w-40px text-end" }
const _hoisted_15 = { class: "min-w-60px text-end" }
const _hoisted_16 = { class: "min-w-60px text-end" }
const _hoisted_17 = { class: "min-w-60px text-end" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = { class: "text-end" }
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "text-end" }

import { ref, onMounted } from "vue";
import TableFooter from "@/components/TableFooter.vue";
import TimeShow from "@/components/TimeShow.vue";
import AccountService from "../services/AccountService";
import i18n from "@/core/plugins/i18n";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import ActivityReport from "./form/ActivityReportForm.vue";
import AccountTradeStat from "./accountTradeStat/AccountTradeStat.vue";
import { handleTradeBuySellDisplay } from "@/core/helpers/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetailTrades',
  props: {
    accountId: {},
    serviceId: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = i18n.global;

const activityReportRef = ref<any>(null);


const isLoading = ref(true);

const trades = ref<any>([]);

const criteria = ref({
  size: 10,
  accountId: props.accountId,
  serviceId: props.serviceId,
} as any);

const fetchData = async (selectedPage: number) => {
  isLoading.value = true;
  criteria.value.page = selectedPage;
  try {
    const responseBody = await AccountService.queryTrades(criteria.value);
    criteria.value = responseBody.criteria;
    trades.value = responseBody.data.map((item: any) => ({
      ticket: item.ticket,
      symbol: item.symbol,
      tp: item.tp,
      volume: item.volume,
      profit: item.profit,
      openTime: item.openAt,
      closeTime: item.closeAt,
      openPrice: item.openPrice,
      closePrice: item.closePrice,
      buySell: t(`type.cmd.${handleTradeBuySellDisplay(item)}`),
    }));
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const showReport = () => {
  activityReportRef.value.show(props.accountId);
};

onMounted(() => {
  fetchData(1);
});

const pageChange = (page: number) => {
  fetchData(page);
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AccountTradeStat, {
      accountId: props.accountId
    }, null, 8, ["accountId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.tradeHistory")), 1),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.$can('SuperAdmin'))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showReport()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("title.activityReport")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.ticket")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.tp")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.symbol")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.buy/Sell")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.openPrice")), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.closePrice")), 1),
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.volume")), 1),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.profit")), 1),
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.openTime")), 1),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("fields.closeTime")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                _createVNode(LoadingRing)
              ]))
            : (!isLoading.value && trades.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                  _createVNode(NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trades.value, (transaction, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "text-center",
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_21, _toDisplayString(transaction.ticket), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(transaction.tp), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(transaction.symbol), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(transaction.buySell), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(transaction.openPrice), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(transaction.closePrice), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(transaction.volume), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass(["text-end", {
                'text-success': transaction.profit >= 0,
                'text-danger': transaction.profit < 0,
              }])
                      }, _toDisplayString(transaction.profit), 3),
                      _createElementVNode("td", _hoisted_28, [
                        _createVNode(TimeShow, {
                          "date-iso-string": transaction.openTime
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", _hoisted_29, [
                        (transaction.closeTime != null)
                          ? (_openBlock(), _createBlock(TimeShow, {
                              key: 0,
                              "date-iso-string": transaction.closeTime
                            }, null, 8, ["date-iso-string"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ]),
      _createVNode(ActivityReport, {
        ref_key: "activityReportRef",
        ref: activityReportRef
      }, null, 512)
    ])
  ], 64))
}
}

})